import type { MeResponse } from '@kidshome/api-contract';

/** Member kinds from the identity read-model (`apps/api` UserKind). */
export type MemberKind = 'parent' | 'relative' | 'child';

/**
 * UI persona derived from the authenticated user. Drives shell selection (kid vs family) and the
 * default theme. Children get the kid shell; parents/relatives get the family/admin shell.
 */
export type Persona = 'kid' | 'family';

export function personaFor(me: Pick<MeResponse, 'kind'>): Persona {
  return me.kind === 'child' ? 'kid' : 'family';
}

export function isGuardian(me: Pick<MeResponse, 'kind'>): boolean {
  return me.kind === 'parent' || me.kind === 'relative';
}

/**
 * A super-admin operator (ADR-0072): a `kind:'platform'` principal with no household. They use the
 * standalone `/platform` console, never the family / household-admin shells. Distinct from an
 * env-allowlisted owner, who is a real household guardian with `isPlatformOwner: true`.
 */
export function isPlatformAdmin(me: Pick<MeResponse, 'kind'>): boolean {
  return me.kind === 'platform';
}
